import React from 'react';
import AppointmentTypes from '../../components/AppointmentTypesPage/AppointmentTypes';
import AssignEmployees from '../../components/AppointmentTypesPage/AssignEmployee';
import AssignedEmployees from '../../components/AppointmentTypesPage/AssignedEmployees';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

function AppointmentTypesPage() {
  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Terminverwaltung
      </Typography>
      <Grid container spacing={4}>
        {/* Appointment Types Section */}
        <Grid item xs={12} md={6}>
          <Paper elevation={3} sx={{ p: 3 }}>
            <Typography variant="h5" component="h2" gutterBottom>
              Terminarten
            </Typography>
            <AppointmentTypes />
          </Paper>
        </Grid>

        {/* Assign Employees Section */}
        <Grid item xs={12} md={6}>
          <Paper elevation={3} sx={{ p: 3 }}>
            <Typography variant="h5" component="h2" gutterBottom>
              Mitarbeiter zuweisen
            </Typography>
            <AssignEmployees />
          </Paper>
        </Grid>

        {/* Assigned Employees Section */}
        <Grid item xs={12}>
          <Paper elevation={3} sx={{ p: 3 }}>
            <Typography variant="h5" component="h2" gutterBottom>
              Zugewiesene Mitarbeiter
            </Typography>
            <AssignedEmployees />
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
}

export default AppointmentTypesPage;
